export default __webpack_public_path__ + "static/media/13_may_b._lonely.2b825346.png";